import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { TestApi } from './testApi'
import { LifeCycle } from '@wix/thunderbolt-symbols'
import { TestApiAppDidMountHandler } from './testApiAppDidMountHandler'
import { TestApiEditorAppDidMountHandler } from './testApiEditorAppDidMountHandler'
import type { ITestApi, TestApiPageConfig } from './types'

export { ITestApi, TestApiPageConfig }

export const page: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageWillMountHandler).to(TestApi)
}

export const site: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.AppDidMountHandler).to(TestApiAppDidMountHandler)
}

export const editor: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.AppDidMountHandler).to(TestApiEditorAppDidMountHandler)
}
